import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { EditIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { usePermissions } from "shared";

import { SecondButtonProps, STEPS } from "../types";

const SecondButton = ({
    isLoading,
    hasNoPermission,
    isEditDisabled,
    isInitialStep,
    selectedConfiguration,
    handleStep,
    handleSubmitEdit
}: SecondButtonProps) => {
    const { t } = useTranslation();
    const { PERMISSIONS, getNoPermissionTooltipTitle } = usePermissions();

    const getInitialStepTooltipTitle = () => {
        if (hasNoPermission) {
            return getNoPermissionTooltipTitle([
                PERMISSIONS.FileRead,
                PERMISSIONS.FileDownload
            ]);
        }

        return isEditDisabled
            ? t("Tct##no editable configurations")
            : undefined;
    };

    return isInitialStep ? (
        <TooltipGeneral
            placement={TOOLTIP_PLACEMENT.Top}
            title={getInitialStepTooltipTitle()}
        >
            <span
                css={css({
                    display: "flex"
                })}
            >
                <Button
                    fullWidth
                    color={BUTTON_COLORS.PrimarySubtle}
                    size={BUTTON_SIZES.Normal}
                    variant={BUTTON_VARIANTS.IconLeft}
                    icon={<EditIcon />}
                    disabled={hasNoPermission || isLoading || isEditDisabled}
                    onClick={() => handleStep(STEPS.EditConfiguration)}
                >
                    {t("Button##edit")}
                </Button>
            </span>
        </TooltipGeneral>
    ) : (
        <Button
            fullWidth
            color={BUTTON_COLORS.Primary}
            size={BUTTON_SIZES.Normal}
            variant={BUTTON_VARIANTS.TextOnly}
            type="submit"
            disabled={isLoading || !selectedConfiguration}
            isLoading={isLoading}
            onClick={handleSubmitEdit}
        >
            {t("Button##continue")}
        </Button>
    );
};

export default SecondButton;
